import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pagination" }

import { inject, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomersPagination',
  setup(__props) {

const store = useStore();
const route = useRoute();
const actProperty: any = inject('actProperty');

const links = [
  'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
  'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
  '0-9',
];

onMounted(() => {
  if (route.params.search) {
    init();
  }
});

const getCustomersAction = async (payload?: { starts_with?: string, company_name?: string, branch_name?: string }) => {
  try {
    await store.dispatch('customers/getCustomers', payload);
  } catch (err: any) {
    actProperty.displayError(err)
  }
};

const init = async () => {
  await getCustomersAction({ starts_with: (route.params.search as string) });
};

watch(() => route.params.search, (newValue) => {
  if (newValue) {
    init();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link, $index) => {
        return _createElementVNode("li", {
          key: $index,
          class: _normalizeClass(["page-item", {active: _ctx.$route.params.search == link}])
        }, [
          _createVNode(_component_router_link, {
            to: {name: 'customerlist', params: {search: `${link}` }},
            class: "page-link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.toUpperCase()), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 2)
      }), 64))
    ])
  ]))
}
}

})